const { START_AMOUNT_GROWTH_ETF_GRAPH } = require('constants/index');
const Immutable = require('immutable');

const buildDataPointForGraph = (data) => {
    if (data) {
        const listPoints = data.toJS();
        if (listPoints[0]) {
            const initialAmount = listPoints[0].value;
            const startPoint = {
                value: START_AMOUNT_GROWTH_ETF_GRAPH,
                date: listPoints[0].date
            }
            const newListPoint = listPoints.map(point => {
                return {
                    value: (point.value * START_AMOUNT_GROWTH_ETF_GRAPH) / initialAmount,
                    date: point.date
                }
            });
            newListPoint[0] = startPoint
            const dataPoints = Immutable.fromJS(newListPoint);
            return dataPoints;
        }
    }
    return null;
}

module.exports = {
    buildDataPointForGraph
}
